import "./styles/App.css";
import { useContext, useEffect } from "react";
import Login from './components/Login';
import {usersMicroserviceUrl} from './microservices/users_microservice.js';
import { Route, Routes, useNavigate, useLocation } from "react-router-dom";
import SubscriptionPlans from "./components/workspace_components/TenantAdministratorComponents/SubscriptionPlans/SubscriptionPlans.jsx";
import { AppContext } from "./components/AppProvider.jsx";
import RootUserHomePage from "./components/workspace_components/RootUserComponents/HomePage/HomePage.jsx";
import RootUserSystemAdministrators from "./components/workspace_components/RootUserComponents/SystemAdministrators/SystemAdministrators.jsx";
import SystemAdministratorProvider from "./components/workspace_components/RootUserComponents/SystemAdministrators/SystemAdministratorProvider.jsx";

import SystemAdministratorHomePage from "./components/workspace_components/SystemAdministratorComponents/HomePage/HomePage.jsx";
import SystemAdministratorTenantAdministrators from "./components/workspace_components/SystemAdministratorComponents/TenantAdministrators/TenantAdministrators.jsx";
import TenantAdministratorProvider from "./components/workspace_components/SystemAdministratorComponents/TenantAdministrators/TenantAdministratorProvider.jsx";
import SystemAdministratorAccountProvider from "./components/workspace_components/SystemAdministratorComponents/Accounts/AccountProvider.jsx";
import SystemAdministratorAccount from "./components/workspace_components/SystemAdministratorComponents/Accounts/Account.jsx";

import TenantAdminHomePage from "./components/workspace_components/TenantAdministratorComponents/HomePage/HomePage.jsx";
import TenantAdminDashboards from "./components/workspace_components/TenantAdministratorComponents/Dashboards/Dashboards.jsx";
import TenantAdminDashboardProvider from "./components/workspace_components/TenantAdministratorComponents/Dashboards/DashboardProvider.jsx";
import TenantAdminDevices from "./components/workspace_components/TenantAdministratorComponents/Devices/Devices.jsx";
import TenantAdminDeviceProvider from "./components/workspace_components/TenantAdministratorComponents/Devices/DeviceProvider.jsx";
import TenantAdminCustomers from "./components/workspace_components/TenantAdministratorComponents/Customers/Customers.jsx";
import TenantAdminCustomerProvider from "./components/workspace_components/TenantAdministratorComponents/Customers/CustomerProvider.jsx";
import InactiveDevicesReports from "./components/workspace_components/TenantAdministratorComponents/InactiveDevicesReports/InactiveDevicesReports.jsx";
import InactiveDevicesReportProvider from "./components/workspace_components/TenantAdministratorComponents/InactiveDevicesReports/InactiveDevicesReportProvider.jsx";
import BillingAccounts from "./components/workspace_components/TenantAdministratorComponents/BillingAccounts/BillingAccounts.jsx";
import CustomerUsers from "./components/workspace_components/TenantAdministratorComponents/Customers/CustomerUsers/CustomerUsers.jsx";
import DashboardState from "./components/workspace_components/TenantAdministratorComponents/Dashboards/DashboardState.jsx";
import TenantAdminDashboard from "./components/workspace_components/TenantAdministratorComponents/Dashboards/Dashboard.jsx";
import TenantAdminAccountProvider from "./components/workspace_components/TenantAdministratorComponents/Accounts/AccountProvider.jsx";
import TenantAdminAccount from "./components/workspace_components/TenantAdministratorComponents/Accounts/Account.jsx";
import TenantInvoices from "./components/workspace_components/TenantAdministratorComponents/Invoices/Invoices.jsx";
import TenantInvoiceProvider from "./components/workspace_components/TenantAdministratorComponents/Invoices/InvoiceProvider.jsx";

import CustomerAdminHomePage from "./components/workspace_components/CustomerAdministratorComponents/HomePage/HomePage.jsx";
import CustomerAdminDashboards from "./components/workspace_components/CustomerAdministratorComponents/Dashboards/Dashboards.jsx";
import CustomerAdminDashboard from "./components/workspace_components/CustomerAdministratorComponents/Dashboards/Dashboard.jsx";
import CustomerAdminDashboardProvider from "./components/workspace_components/CustomerAdministratorComponents/Dashboards/DashboardProvider.jsx";
import CustomerAdminDevices from "./components/workspace_components/CustomerAdministratorComponents/Devices/Devices.jsx";
import CustomerAdminCustomers from "./components/workspace_components/CustomerAdministratorComponents/Customers/Customers.jsx";
import CustomerAdminAccountProvider from "./components/workspace_components/CustomerAdministratorComponents/Accounts/AccountProvider.jsx";
import CustomerAdminAccount from "./components/workspace_components/CustomerAdministratorComponents/Accounts/Account.jsx";
import CustomerAdminInvoices from "./components/workspace_components/CustomerAdministratorComponents/Invoices/Invoices.jsx";
import CustomerAdminInvoiceProvider from "./components/workspace_components/CustomerAdministratorComponents/Invoices/InvoiceProvider.jsx";

import CustomerUserHomePage from "./components/workspace_components/CustomerUserComponents/HomePage/HomePage.jsx";
import CustomerUserDashboards from "./components/workspace_components/CustomerUserComponents/Dashboards/Dashboards.jsx";
import CustomerUserDashboard from "./components/workspace_components/CustomerUserComponents/Dashboards/Dashboard.jsx";
import CustomerUserDashboardProvider from "./components/workspace_components/CustomerUserComponents/Dashboards/DashboardProvider.jsx";
import CustomerUserDevices from "./components/workspace_components/CustomerUserComponents/Devices/Devices.jsx";
import CustomerUserAccountProvider from "./components/workspace_components/CustomerUserComponents/Accounts/AccountProvider.jsx";
import CustomerUserAccount from "./components/workspace_components/CustomerUserComponents/Accounts/Account.jsx";

import { thingsBoardMicroserviceUrl } from "./microservices/thingsboard_microservice.js";
const App = () => {
    const {
        user, isAuthenticated, login, logout,
        userProfile,setUserProfile,
        customerIotProfile,setCustomerIotProfile,
        selectedComponent,setSelectedComponent
     } = useContext(AppContext);
    const navigate = useNavigate();
    const location = useLocation();
    const fetchAndSetUserProfile = async() =>{
        if(isAuthenticated){
            try{
                const profileUrl = usersMicroserviceUrl + '/profile';
                const response = await fetch(profileUrl,{
                    method:'GET',
                    headers:{
                        'Authorization':`Bearer ${user.access_token}`
                    }
                });
                if(!response.ok) throw new Error("Network response was not ok");
                const responseData = await response.json();
                setUserProfile(responseData);
            }
            catch(error){
                console.error("An error occurred when fetching user profile",error);
                //logout();
            }
        }
    };
    const fetchAndSetCustomerIotProfile = async() =>{
        try{
            const url = `${thingsBoardMicroserviceUrl}/customers/users/shared/${encodeURIComponent(user.profile.sub)}/profile`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Bearer ${user.access_token}`
                }
            });
            if(response.ok){
                const responseData = await response.json();
                setCustomerIotProfile(responseData);
            }
            else throw new Error(`status code: ${response.status}`)
        }
        catch(error){
            console.error('An error occurred when retrieving the customer iot profile from the server',error);
        }
    };
    const disableDevTools = () =>{
        document.addEventListener('contextmenu',function(e){e.preventDefault()});
        document.addEventListener('keydown',function(e){
            if(e.key === 'F12' || (e.ctrlKey && e.shiftKey && ['I','C','J'].includes(e.key.toUpperCase()))) e.preventDefault();
        });
    };
    useEffect(() => {
        fetchAndSetUserProfile();
    },[isAuthenticated,user]);
    useEffect(() =>{
        if(userProfile && userProfile?.role === 'CUSTOMER') fetchAndSetCustomerIotProfile();
        if(userProfile && location.pathname.startsWith('/callback')) navigate('/');
    },[userProfile]);
    useEffect(() => {
        if(isAuthenticated && userProfile?.role === 'CUSTOMER' && customerIotProfile?.role === 'ADMIN') {
            if (customerIotProfile?.defaultDashboardId) {
                navigate(`/customers/admin/${customerIotProfile.id}/dashboards/${customerIotProfile.defaultDashboardId}/`);
            }
        }
        else if(isAuthenticated && userProfile?.role === 'CUSTOMER' && customerIotProfile?.role === 'USER') {
            if (customerIotProfile?.defaultDashboardId) {
                navigate(`/customers/user/${customerIotProfile.id}/dashboards/${customerIotProfile.defaultDashboardId}/`);
            }
        }
    }, [isAuthenticated, userProfile, customerIotProfile]);
    useEffect(() =>{
        // disableDevTools();
    },[]);
    const getHomeComponent = () =>{
        if(!userProfile || !userProfile.role){
            return <></>
        }
        switch(userProfile.role){
            case 'ROOT':
                return <RootUserHomePage/>;
            case 'SYSTEM_ADMIN':
                return <SystemAdministratorHomePage/>;
            case 'TENANT_ADMIN':
                return <TenantAdminHomePage/>;
            case 'CUSTOMER':
                return customerIotProfile && customerIotProfile.role === 'ADMIN'? <CustomerAdminHomePage/>:
                customerIotProfile && customerIotProfile.role === 'USER'? <CustomerUserHomePage/>:<></>
            default:
                console.log(userProfile);
                return <div>Unauthorized access</div>;
        };
    };
    return(
        <Routes>
            <Route path="/" element=
                {isAuthenticated ? (userProfile? (getHomeComponent()):(<></>)) : (<Login login={login}/>)}
            />
            <Route path="/callback" element={<></>}/>
            <Route path="/root-user/system-admins" element={<SystemAdministratorProvider><RootUserSystemAdministrators/></SystemAdministratorProvider>}/>
            <Route path="/system-admin/tenant-admins" element={<TenantAdministratorProvider><SystemAdministratorTenantAdministrators/></TenantAdministratorProvider>}/>
            <Route path="/system-admin/accounts" element={<SystemAdministratorAccountProvider><SystemAdministratorAccount/></SystemAdministratorAccountProvider>}/>

            <Route path="/tenants/dashboards" element={
                <TenantAdminDashboardProvider>
                    <TenantAdminDashboards/>
                </TenantAdminDashboardProvider>
            }/>
            <Route path="/tenants/devices" element={<TenantAdminDeviceProvider><TenantAdminDevices/></TenantAdminDeviceProvider>}/>
            <Route path="/tenants/customers" element={<TenantAdminCustomerProvider><TenantAdminCustomers/></TenantAdminCustomerProvider>}/>
            <Route path="/tenants/customers/:customerId/users" element={<TenantAdminCustomerProvider><CustomerUsers/></TenantAdminCustomerProvider>}/>
            <Route path="/tenants/inactive-devices/reports" element={<InactiveDevicesReportProvider><InactiveDevicesReports/></InactiveDevicesReportProvider>}/>
            <Route path="/tenants/billing-accounts" element={<BillingAccounts/>}/>
            <Route path="/tenants/subscription-plans" element={<SubscriptionPlans/>}/>
            <Route path="/tenants/accounts" element={<TenantAdminAccountProvider><TenantAdminAccount/></TenantAdminAccountProvider>}/>
            <Route path="/tenants/invoices/:invoiceIdPathVariable?" element={<TenantInvoiceProvider><TenantInvoices/></TenantInvoiceProvider>}/>
            <Route exact path="/tenants/:tenantId/dashboards/:dashboardId" element={
                <TenantAdminDashboardProvider>
                    <TenantAdminDashboard/>
                </TenantAdminDashboardProvider>
            }/>
            <Route path="/tenant/dashboard/state" element={
                <TenantAdminDashboardProvider>
                    <DashboardState/>
                </TenantAdminDashboardProvider>
            }/>
            <Route path="/customers/admin/dashboards" element={
                <CustomerAdminDashboardProvider>
                    <CustomerAdminDashboards/>
                </CustomerAdminDashboardProvider>
            }/>
            <Route path="/customers/admin/:customerAdminId/dashboards/:dashboardId" element={
                <CustomerAdminDashboardProvider>
                    <CustomerAdminDashboard/>
                </CustomerAdminDashboardProvider>
            }/>
            <Route path="/customers/admin/devices" element={<CustomerAdminDevices/>}/>
            <Route path="/customers/admin/customers" element={<CustomerAdminCustomers/>}/>
            <Route path="/customers/admin/accounts" element={<CustomerAdminAccountProvider><CustomerAdminAccount/></CustomerAdminAccountProvider>}/>
            <Route path="/customers/admin/invoices" element={<CustomerAdminInvoiceProvider><CustomerAdminInvoices/></CustomerAdminInvoiceProvider>}/>
            <Route path="/customers/user/dashboards" element={
                <CustomerUserDashboardProvider>
                    <CustomerUserDashboards/>
                </CustomerUserDashboardProvider>
            }/>
            <Route path="/customers/user/:customerUserId/dashboards/:dashboardId" element={
                <CustomerUserDashboardProvider>
                    <CustomerUserDashboard/>
                </CustomerUserDashboardProvider>
            }/>
            <Route path="/customers/user/devices" element={<CustomerUserDevices/>}/>
            <Route path="/customers/user/accounts" element={<CustomerUserAccountProvider><CustomerUserAccount/></CustomerUserAccountProvider>}/>
        </Routes>
    );
};

export default App;